import React from "react"
import styled from "@emotion/styled"
import VerticalMenu from "../../../components/ui/verticalMenu/verticalMenu"
import { howToArticles } from "./howToArticles"
import { generatePath, Route, Switch, withRouter } from "react-router-dom"
import * as routes from "../../../library/constants/routes"
import HowToArticle from "./howToArticle"
import { devices } from "../../../library/constants/styles/responsive"

const Container = styled.div`
  display: flex;

  @supports (display: grid) {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: 1fr 240px;

    @media ${devices.xs} {
      grid-template-columns: auto;
    }
  }
`

const Main = styled.main`
  margin-bottom: 15px;
  margin-right: 15px;
  width: 915px;

  @supports (display: grid) {
    display: grid;
    grid-auto-rows: max-content;
    grid-gap: 15px;
    width: auto;
    margin-right: 0;
  }

  @media ${devices.xs} {
    width: 100%;
  }
`

const HowTo = (props) => {
  const menuItems = [
    // {label: "FAQ", path: routes.HOW_TO_FAQ},
    ...howToArticles.map((article, index) => ({
      label: article.menuLabel || article.title,
      path: generatePath(routes.HOW_TO, { articleId: article.slug }),
      type: article.isChild ? "child" : "parent",
    })),
  ]

  return (
    <Container>
      <Main>
        <Switch>
          {howToArticles.map((article) => (
            <Route
              exact
              path={generatePath(routes.HOW_TO, { articleId: article.slug })}
            >
              <HowToArticle article={article} />
            </Route>
          ))}
        </Switch>
        {/*{props.match.path === routes.HOW_TO_GENERAL && <HowToGeneral />}*/}
        {/*/!*{props.match.path === routes.HOW_TO_FAQ && <FAQ />}*!/*/}
        {/*{props.match.path === routes.HOW_TO && <HowToArticle />}*/}
      </Main>
      <aside className="common-page__sidebar">
        <VerticalMenu menuItems={menuItems} />
      </aside>
    </Container>
  )
}

export default withRouter(HowTo)
